import { render } from "./AdditionalInfo.vue?vue&type=template&id=92834ec2&scoped=true"
import script from "./AdditionalInfo.vue?vue&type=script&lang=js"
export * from "./AdditionalInfo.vue?vue&type=script&lang=js"

import "./AdditionalInfo.vue?vue&type=style&index=0&id=92834ec2&lang=scss&scoped=true"
import "./AdditionalInfo.vue?vue&type=style&index=1&id=92834ec2&lang=css"
script.render = render
script.__scopeId = "data-v-92834ec2"

export default script